export default __webpack_public_path__ + "static/sweepstakes-grand-5-374db7c58d1fa77c68537a38a24f3354.jpg";